
export class Badge {
    // constructor(badge) {
    //     this.Id = badge.Id;
    // }

    static makeId(isoDate, type){
        return isoDate+"_"+type;
    }

    // getCurrentTargets() {
    //     return this.getTargets(Date.now())
    // }
    //
    // getTargets(date) {
    //     var date1=new Date(date);
    //     if (!this.targets || !this.targets.Dates)
    //         return undefined;
    //     var pastValues=this.targets.Dates.filter(x=> new Date(x.Date) <= date1);
    //     return pastValues[0];
    // }

}